export default __webpack_public_path__ + "static/media/brow-wax.a747814a.svg";